import { useLocalSearchParams } from 'expo-router'

import { EmailScreen } from '@/src/features/auth/ui/screens/EmailScreen'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'

export default () => {
  const searchParams = filterSearchParams(useLocalSearchParams())
  return <EmailScreen searchParams={searchParams} />
}
